import { NavSchema } from './Nav.styles';

export const navStyles: NavSchema = {
  wrapper: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'flex-start',
    bg: 'blackAlpha.400',
    w: 'full',
    boxShadow:
      '0px 1px 0px 0px rgba(255, 255, 255, 0.10), 0px 3px 5px 0px rgba(0, 0, 0, 0.20) inset',
    borderRadius: 'md',
    minH: '9',
    h: 'auto',
    px: '4',
    mx: '0',
    mt: '0',
    mb: '3',
    sx: {
      '&[data-isonsportsall="true"]': {
        pb: '0',
      },
    },
  },
  link: {
    boxShadow: 'none',
    border: 'none',
    fontSize: 'sm',
    textShadow: 'none',
    fontWeight: 'normal',
    borderRadius: 'none',
    lineHeight: '1.7',
    fontFamily: 'Staatliches',
    h: '10',
    color: 'white',
    borderBottom: '4px solid',
    borderBottomColor: 'transparent',
    px: '3',
    pt: '2',
    pb: '1',
    sx: {
      '&.active': {
        color: 'beta.500',
        fontWeight: 'normal',
        textShadow: '0px 0px 8px rgba(251, 201, 21, 0.50)',
        border: 'none',
        borderBottom: '4px solid',
        borderBottomColor: 'beta.500',
      },
    },
  },
};
